import React from 'react';
import '../../Hero.css';

function ProjectsDescription() {
  return (
    <div className="projects-description">
      <h1>
        My <span className="highlight">Projects</span>
      </h1>
      <p className="page-subtitle">
        Work a recruiter can diligence: production AWS, team leadership, and an MLH-winning accessibility prototype.
      </p>
    </div>
  );
}

export default ProjectsDescription;
